import TransactionsGetStarted from "../GetStarted/TransactionsGetStarted"

const AddTransactionsPrompt = ({ className }) => {
    return (
        <div className={`text-center ${className}`}>
            <h3 className="text-center spc-m-t-1 spc-m-b-2">
                Add Transactions
            </h3>

            <TransactionsGetStarted />
        </div>
    )
}

export default AddTransactionsPrompt